import configJson from   '../../Config.json';
const Signout = async () => {
//window.location.href = configJson.AdfsLogoutURL;
localStorage.clear();
sessionStorage.clear();
window.location.href="/";
};
export default Signout;